import type {
  CreateGuestProfileRequestDto,
  EnrollGuestLoyaltyRequestDto,
  MergeGuestProfilesRequestDto,
  SyncGuestStayHistoryRequestDto,
  UpdateGuestContactDetailsRequestDto,
  UpdateGuestMarketingRequestDto,
  UpsertGuestPreferenceRequestDto,
} from "./dtos.ts";

function required(value: string | undefined, message: string) {
  return value?.trim() ? "" : message;
}

function validEmail(value: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function validateCreateGuestProfileRequest(input: CreateGuestProfileRequestDto) {
  return {
    profileId: required(input.profileId, "Profile id is required."),
    guestId: required(input.guestId, "Guest is required."),
  };
}

export function validateUpdateGuestContactDetailsRequest(input: UpdateGuestContactDetailsRequestDto) {
  const errors: Record<string, string> = {
    guestId: required(input.guestId, "Guest is required."),
  };

  const invalidEmail = input.emails?.find((entry) => entry.email.trim() && !validEmail(entry.email.trim()));
  if (invalidEmail) {
    errors.emails = "All email contacts must be valid email addresses.";
  }

  return errors;
}

export function validateUpsertGuestPreferenceRequest(input: UpsertGuestPreferenceRequestDto) {
  const errors: Record<string, string> = {
    guestId: required(input.guestId, "Guest is required."),
    preferenceId: required(input.preferenceId, "Preference id is required."),
    label: required(input.label, "Preference label is required."),
  };

  if (input.scope === "stay" && !input.stayId && !input.reservationId) {
    errors.scope = "Stay-level preferences require a stay or reservation reference.";
  }

  return errors;
}

export function validateEnrollGuestLoyaltyRequest(input: EnrollGuestLoyaltyRequestDto) {
  return {
    guestId: required(input.guestId, "Guest is required."),
    programId: required(input.programId, "Program is required."),
    memberId: required(input.memberId, "Member id is required."),
  };
}

export function validateUpdateGuestMarketingRequest(input: UpdateGuestMarketingRequestDto) {
  return {
    guestId: required(input.guestId, "Guest is required."),
    segmentIds: input.segmentIds.length > 0 ? "" : "At least one segment is required.",
    segmentLabels: input.segmentLabels.length > 0 ? "" : "At least one segment label is required.",
  };
}

export function validateMergeGuestProfilesRequest(input: MergeGuestProfilesRequestDto) {
  const errors: Record<string, string> = {
    targetGuestId: required(input.targetGuestId, "Target guest is required."),
    sourceGuestId: required(input.sourceGuestId, "Source guest is required."),
  };
  if (input.targetGuestId && input.targetGuestId === input.sourceGuestId) {
    errors.sourceGuestId = "Source and target guests must be different.";
  }
  return errors;
}

export function validateSyncGuestStayHistoryRequest(input: SyncGuestStayHistoryRequestDto) {
  return {
    guestId: required(input.guestId, "Guest is required."),
  };
}
